import { ActionReducer, Action } from '@ngrx/store';
import { merge, pick } from 'lodash-es';
import { getSavedState, setSavedState} from '../../shared/helpers/session-storage-helper';
import * as fromActions from './dynamic.actions';
import { SubscriptionManagerService } from './subscription-manager.service';

// the keys from state which we'd like to save.
const stateKeys = ['session'];

export function dynamicMetaReducer<S, A extends Action = Action>(reducer: ActionReducer<S, A>) {
    let onInit = true; // after load/refresh…
    return function (state: S, action: A): S {
        const nextState = reducer(state, action);
        if (onInit) {
            onInit = false;
            const savedState = getSavedState();
            // Alte Session Struktur löschen
            if (savedState && savedState['session'] && Array.isArray(savedState['session'])) {
                savedState['session'] = {};
            }
            return merge(nextState, savedState);
        }

        const stateToSave = pick(nextState, stateKeys);
        setSavedState(stateToSave);
        return nextState;
    };
}

/**
 * Meta-Reducer Factory: Unsubscribed Subscriptions synchron VOR dem Reducer,
 * damit kein Timing-Problem zwischen Reducer und Effect entsteht.
 */
export function subscriptionMetaReducerFactory(subscriptionManager: SubscriptionManagerService) {
    return function<S, A extends Action>(reducer: ActionReducer<S, A>): ActionReducer<S, A> {
        return function(state: S, action: A): S {
            //console.warn(`Action dispatched: ${action.type}`);
            if (action.type === fromActions.initLocalStore.type) {
                subscriptionManager.UnsubscribeAllActions();
            } else if (action.type === fromActions.initChildStore.type) {
                const path = (action as any).storeDataChildNames.length > 0 ? (action as any).storeDataChildNames.join(".") : "";
                subscriptionManager.UnsubscribeActionsFromPath(path);
            }
            return reducer(state, action);
        };
    };
}